import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  
  const scrollToCTA = () => {
    const cta = document.getElementById('cta');
    if (cta) {
      const headerHeight = 72;
      const top = cta.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container-max px-6 sm:px-8 lg:px-12">
        <div className="max-w-2xl mx-auto text-center">
          {/* Logo y nombre */}
          <div 
            className="flex items-center justify-center mb-6 cursor-pointer" 
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <div className="w-12 h-12 bg-primary-600 rounded-2xl flex items-center justify-center mr-4">
              <span className="text-white font-bold text-xl">T</span>
            </div>
            <span className="text-2xl sm:text-3xl font-bold text-white">Tareia</span>
          </div>
          
          {/* Frase de valor */}
          <p className="text-lg sm:text-xl text-gray-300 mb-8 leading-relaxed">
            "Deja de perder horas preparando actividades para tus clases."
          </p>
          
          {/* CTA Button */}
          <button 
            onClick={scrollToCTA}
            className="bg-gradient-to-r from-primary-600 to-secondary-600 hover:from-primary-700 hover:to-secondary-700 text-white font-bold py-3 sm:py-4 px-6 sm:px-8 rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 text-base sm:text-lg mb-6"
          >
            🚀 Quiero acceso anticipado
          </button>
          
          {/* Texto de confianza */}
          <p className="text-gray-400 mb-12">
            Diseñado para docentes de Latinoamérica
          </p>
          
          {/* Links legales */}
          <div className="flex justify-center space-x-4 sm:space-x-6 mb-8">
            <button 
              onClick={() => navigate('/privacidad')}
              className="text-gray-400 hover:text-white transition-colors text-sm"
            >
              Privacidad
            </button>
            <span className="text-gray-600">|</span>
            <button 
              onClick={() => navigate('/terminos')}
              className="text-gray-400 hover:text-white transition-colors text-sm"
            >
              Términos
            </button>
          </div>
          
          {/* Copyright */}
          <div className="text-gray-500 text-sm">
            © 2026 Tareia
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;